import { render, staticRenderFns } from "./TooltipTemplate.vue?vue&type=template&id=1021509c&scoped=true"
import script from "./TooltipTemplate.vue?vue&type=script&lang=ts"
export * from "./TooltipTemplate.vue?vue&type=script&lang=ts"
import style0 from "./TooltipTemplate.vue?vue&type=style&index=0&id=1021509c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021509c",
  null
  
)

export default component.exports